<script>

export default {
    data(){
        return{

        }
    },

    created(){
            let dataEncoded = this.$route.params.key; 
            let data = JSON.parse(atob(dataEncoded));

            if(data.type==3){
                this.$router.push({
                    name : 'student-class-report',
                    params : data
                }).catch(err => {}); 
            }
             if(data.type==1){
              
                this.$router.push({
                    name : 'evaluation-review',
                    params : data
                }).catch(err => {}); 

            }
        
     
         
	},
    methods: {
      
    }
}
</script>